import Proof from './proof'

export default {
  getFileProof: Proof
}
